export type PortalRole = 'Admin' | 'Manager' | 'Rep';

export const PORTAL_ROLES: readonly PortalRole[] = ['Admin', 'Manager', 'Rep'];

interface RoleAccess {
  approvals: boolean;
  administration: boolean;
  organizationSales: boolean;
  createEvents: boolean;
}

export const ROLE_ACCESS: Record<PortalRole, RoleAccess> = {
  Admin: { approvals: true, administration: true, organizationSales: true, createEvents: true },
  Manager: { approvals: true, administration: false, organizationSales: true, createEvents: true },
  Rep: { approvals: false, administration: false, organizationSales: false, createEvents: false },
};

export function canApprove(role: PortalRole | null | undefined): boolean {
  return role ? ROLE_ACCESS[role]?.approvals ?? false : false;
}

export function canAccessAdministration(role: PortalRole | null | undefined): boolean {
  return role ? ROLE_ACCESS[role]?.administration ?? false : false;
}

export function hasOrganizationSalesScope(role: PortalRole | null | undefined): boolean {
  return role ? ROLE_ACCESS[role]?.organizationSales ?? false : false;
}

export function canCreateEvents(role: PortalRole | null | undefined): boolean {
  return role ? ROLE_ACCESS[role]?.createEvents ?? false : false;
}
